import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PLACE'

export default [
  // places
  {
    path: '/places',
    name: 'page-places',
    component: () => import('@/pages/places'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/place/new',
    name: 'page-place-new',
    component: () => import('@/pages/place'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/place/:id',
    name: 'page-place',
    component: () => import('@/pages/place'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
